(function () {
  function cardStep(track) {
    const card = track.querySelector('.nw-testimonials__card');
    if (!card) return track.clientWidth;
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function updateNav(track, prev, next) {
    const max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }

  function bind(root) {
    if (!root || root.dataset.nwTestimonialsInit === '1') return;
    root.dataset.nwTestimonialsInit = '1';

    const track = root.querySelector('[data-nw-testimonials-track]');
    const prev = root.querySelector('[data-nw-testimonials-prev]');
    const next = root.querySelector('[data-nw-testimonials-next]');
    if (!track) return;

    function go(direction) {
      track.scrollBy({ left: direction * cardStep(track), behavior: 'smooth' });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        go(-1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        go(1);
      });
    }

    track.addEventListener(
      'scroll',
      function () {
        updateNav(track, prev, next);
      },
      { passive: true }
    );

    updateNav(track, prev, next);
  }

  function init(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-nw-testimonials]').forEach(bind);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
